import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SelectedIcon from '../selected-icon';
import Icon from '../icon';
import Tag from '../tag';
import Heading from '../heading';
import Paragraph from '../paragraph';
import { iconsList } from '../icon/glyphs';
import InteractiveBox from '../interactive-box';
import { VERTICAL_ALIGN } from './constants';

const CardSelector = ({
  iconGlyph = null,
  description = '',
  selected = false,
  premium = false,
  verticalAlign = VERTICAL_ALIGN.start,
  title,
  onClick,
}) => {
  const classes = classNames('ws-ui-card-selector', `ws-ui-card-selector--${verticalAlign}`);
  const isFocusable = !selected;

  return (
    <div className={classes}>
      <InteractiveBox selected={selected} focusable={isFocusable} onClick={onClick}>
        <div className="ws-ui-card-selector__container">
          {(selected || premium) && (
            <div className="ws-ui-card-selector__float-box">
              {premium && <Tag iconGlyph="star" appearance="cta" size="small" />}
              {selected && !premium && <SelectedIcon />}
            </div>
          )}
          {iconGlyph && (
            <div className="ws-ui-card-selector__icon">
              <Icon glyph={iconGlyph} type="inherit" size="100%" />
            </div>
          )}
          <div className="ws-ui-card-selector__content">
            <Heading type="heading-6">{title}</Heading>
            {description && <Paragraph>{description}</Paragraph>}
          </div>
        </div>
      </InteractiveBox>
    </div>
  );
};

CardSelector.propTypes = {
  iconGlyph: PropTypes.oneOf(iconsList),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  selected: PropTypes.bool,
  premium: PropTypes.bool,
  verticalAlign: PropTypes.oneOf(Object.values(VERTICAL_ALIGN)),
  onClick: PropTypes.func.isRequired,
};

export default CardSelector;
